<template>
  <div class="content-creation">
    <v-card class="mt-6 mb-6">
      <v-card-title>Nouvel UTM Content suivi</v-card-title>
      <v-row class="mr-6 ml-6">
        <v-col cols="12" md="6">
          <v-text-field
            v-model="content.content"
            label="Content"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="content.label"
            label="Label (optionnel)"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-switch
            v-model="content.is_active"
            label="Actif"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-12 pb-6">
        <v-btn class="ml-6 mr-6 secondary" @click="saveContent"
          >Enregistrer</v-btn
        >
        <v-btn class="ml-6 mr-6 primary" @click="cancelContent">Annuler</v-btn>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import useAxios from "@/hooks/useAxios";
export default {
  name: "UtmContentCreation",
  components: {},
  data() {
    return {
      content: {
        content: "",
        label: "",
        is_active: true,
      },
    };
  },
  setup() {
    const { axiosGet, axiosPost, isLoading } = useAxios();

    return {
      axiosGet,
      isLoading,
      axiosPost,
    };
  },
  methods: {
    resetContent() {
      this.content = {
        content: "",
        label: "",
        is_active: true,
      };
    },
    cancelContent() {
      this.resetContent();
      this.$emit("close-dialog");
    },
    async saveContent() {
      const params = {
        content: this.content.content,
        label: this.content.label,
        is_active: this.content.is_active,
      };
      try {
        await this.axiosPost(`/acquisition/utm-content/`, params);
      } catch (error) {
        console.error("Error saving UTM Content:", error);
        alert(
          "Erreur lors de la création de l'UTM Content. Vérifier l'intégrité des données (doublons)."
        );
        this.cancelContent();
        return;
      }
      this.resetContent();
      this.$emit("saved");
    },
  },
  computed: {},
};
</script>
<style scoped>
.content-creation {
  max-width: 1000px;
  margin: 0 auto;
}
</style>
